import styles from './Choice.module.scss';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Choice = () => {
  const theme = useSelector((state) => state.header.theme);
  return (
    <section className={theme ? [styles.choice, styles.light].join(' ') : styles.choice}>
      <div className={styles.choice__container}>
        <h2 className={styles.choice__title}>Выберите интересующий инструмент</h2>
        <div className={styles.choice__body}>
          <Link to="/randomnumber" className={styles.choice__item}>
            <div className={styles.choice__img}>
              <svg
                fill="none"
                height="24"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.75 4C10.2688 4 11.5 5.23122 11.5 6.75V17.25C11.5 18.7688 10.2688 20 8.75 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75C2 5.23122 3.23122 4 4.75 4H8.75ZM8.75 5.5H4.75C4.05964 5.5 3.5 6.05964 3.5 6.75V17.25C3.5 17.9404 4.05964 18.5 4.75 18.5H8.75C9.44036 18.5 10 17.9404 10 17.25V6.75C10 6.05964 9.44036 5.5 8.75 5.5ZM19.25 4C20.7688 4 22 5.23122 22 6.75V17.25C22 18.7688 20.7688 20 19.25 20H15.25C13.7312 20 12.5 18.7688 12.5 17.25V6.75C12.5 5.23122 13.7312 4 15.25 4H19.25ZM19.25 5.5H15.25C14.5596 5.5 14 6.05964 14 6.75V17.25C14 17.9404 14.5596 18.5 15.25 18.5H19.25C19.9404 18.5 20.5 17.9404 20.5 17.25V6.75C20.5 6.05964 19.9404 5.5 19.25 5.5ZM6 9V15C6 15.4142 6.33579 15.75 6.75 15.75C7.16421 15.75 7.5 15.4142 7.5 15V9C7.5 8.58579 7.16421 8.25 6.75 8.25C6.33579 8.25 6 8.58579 6 9ZM17.5 9.75V11.25H16.25C15.8358 11.25 15.5 11.5858 15.5 12V15C15.5 15.4142 15.8358 15.75 16.25 15.75H18.25C18.6642 15.75 19 15.4142 19 15C19 14.5858 18.6642 14.25 18.25 14.25H17V12.75H18.25C18.6642 12.75 19 12.4142 19 12V9C19 8.58579 18.6642 8.25 18.25 8.25H16.25C15.8358 8.25 15.5 8.58579 15.5 9C15.5 9.41421 15.8358 9.75 16.25 9.75H17.5Z"
                  fill="#000000"
                />
              </svg>
            </div>
            <div className={styles.choice__name}>Случайное число</div>
          </Link>
          <Link to="/randompassword" className={styles.choice__item}>
            <div className={styles.choice__img}>
              <svg
                data-name="Layer 1"
                height="200"
                id="Layer_1"
                viewBox="0 0 200 200"
                width="200"
                xmlns="http://www.w3.org/2000/svg">
                <title />
                <path d="M145,80H70V60A20.06,20.06,0,0,1,90,40h22.5A17.72,17.72,0,0,1,130,57.5a10,10,0,0,0,20,0A37.77,37.77,0,0,0,112.5,20H90A40.12,40.12,0,0,0,50,60V80.5A30.08,30.08,0,0,0,25,110v40a30.09,30.09,0,0,0,30,30h90a30.09,30.09,0,0,0,30-30V110A30.09,30.09,0,0,0,145,80Zm10,70a10,10,0,0,1-10,10H55a10,10,0,0,1-10-10V110a10,10,0,0,1,10-10h90a10,10,0,0,1,10,10Z" />
              </svg>
            </div>
            <div className={styles.choice__name}>Генератор паролей</div>
          </Link>
          <Link to="/qr" className={styles.choice__item}>
            <div className={styles.choice__img}>
              <svg
                fill="none"
                height="24"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  clipRule="evenodd"
                  d="M9 3H3V9H5V5H9V3ZM3 21V15H5V19H9V21H3ZM15 3V5H19V9H21V3H15ZM19 15H21V21H15V19H19V15ZM7 7H11V11H7V7ZM7 13H11V17H7V13ZM17 7H13V11H17V7ZM13 13H17V17H13V13Z"
                  fill="#000000"
                  fillRule="evenodd"
                />
              </svg>
            </div>
            <div className={styles.choice__name}>Генератор QR</div>
          </Link>
          <Link to="/wish" className={styles.choice__item}>
            <div className={styles.choice__img}>
              <svg
                enableBackground="new 0 0 48 48"
                height="48px"
                id="Layer_1"
                version="1.1"
                viewBox="0 0 48 48"
                width="48px">
                <g>
                  <path
                    d="M28.084,21.295h-8.23c-0.841,0-1.522,0.682-1.522,1.522v8.23c0,0.84,0.682,1.523,1.522,1.523h8.23   c0.841,0,1.522-0.684,1.522-1.523v-8.23C29.606,21.977,28.925,21.295,28.084,21.295z"
                    fill="#000000"
                  />
                  <path
                    d="M24,0C10.745,0,0,10.745,0,24s10.745,24,24,24s24-10.745,24-24S37.255,0,24,0z M32.362,33.661   c0,0.852-0.689,1.541-1.539,1.541H17.177c-0.851,0-1.539-0.689-1.539-1.541V20.016c0-0.85,0.688-1.539,1.539-1.539h2.919   c0.783,0,0-0.426,0-0.426l0.003-0.008c-0.358-0.19-0.704-0.392-0.996-0.616c-0.333-0.218-0.604-0.516-0.803-0.862   c-0.01-0.018-0.024-0.033-0.033-0.05c0.001-0.001,0.003-0.002,0.004-0.003c-0.192-0.357-0.313-0.759-0.313-1.193   c0-1.393,1.128-2.521,2.521-2.521c1.192,0,2.187,0.831,2.448,1.944l0.005-0.003c0,0,0.37,1.441,0.675,2.745h0.001   c0,0,0.426,1.491,0.785,0c0.001-0.003,0.002-0.004,0.002-0.007c0.305-1.302,0.674-2.738,0.674-2.738l0.005,0.003   c0.262-1.113,1.256-1.944,2.448-1.944c1.393,0,2.521,1.128,2.521,2.521c0,0.435-0.12,0.836-0.313,1.193   c0.001,0.001,0.003,0.002,0.004,0.003c-0.009,0.017-0.023,0.032-0.033,0.05c-0.198,0.347-0.47,0.645-0.803,0.862   c-0.282,0.216-0.613,0.411-0.958,0.596l0.013,0.003c0,0-0.876,0.451,0,0.451h2.871c0.85,0,1.539,0.689,1.539,1.539V33.661z"
                    fill="#000000"
                  />
                </g>
              </svg>
            </div>
            <div className={styles.choice__name}>Генератор комплиментов</div>
          </Link>
          <Link to="/converter" className={styles.choice__item}>
            <div className={styles.choice__img}>
              <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                <g id="Money_asset_income_management">
                  <path d="M32.4436,1.2458a16.0708,16.0708,0,1,0,16.07,16.0708A16.0708,16.0708,0,0,0,32.4436,1.2458ZM31.1853,16.1787H33.656a4.1749,4.1749,0,0,1,.0078,8.35v2.0569a1.35,1.35,0,1,1-2.6992,0V24.5292H28.1482a1.35,1.35,0,0,1,0-2.7H33.656a1.4751,1.4751,0,1,0,0-2.95H31.1853a4.3788,4.3788,0,0,1-.2207-8.7525V8.0478a1.35,1.35,0,1,1,2.6992,0v2.0561H36.739a1.35,1.35,0,0,1,0,2.7H31.1853a1.6873,1.6873,0,1,0,0,3.3746Z" />
                  <path d="M15.1059,36.736H8.5481A1.0434,1.0434,0,0,0,7.5046,37.78V60.1611a1.0435,1.0435,0,0,0,1.0435,1.0434h6.5578A2.2745,2.2745,0,0,0,17.38,58.93V39.01A2.2745,2.2745,0,0,0,15.1059,36.736Z" />
                  <path d="M56.3279,39.3642a3.8044,3.8044,0,0,0-3.1846-1.7158h-2.57a5.5491,5.5491,0,0,0-5.1455,3.4429A5.75,5.75,0,0,1,44.4036,42.71,8.3781,8.3781,0,0,1,37.72,46.5092l-7.6123.0005a1.35,1.35,0,0,1,0-2.7h7.5762a5.0783,5.0783,0,0,0,2.7244-.8766l0-.0457A5.2188,5.2188,0,0,0,35.19,37.6484h-5.586a7.7365,7.7365,0,0,0-5.497,2.27l-.1426.1421a7.2471,7.2471,0,0,1-3.8858,2.0127V56.9848H40.45A15.43,15.43,0,0,0,54.64,47.6381l2.0068-4.6709A3.802,3.802,0,0,0,56.3279,39.3642Z" />
                </g>
              </svg>
            </div>
            <div className={styles.choice__name}>Конвертер валют</div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Choice;
